<div class="container-fluid mt-2 pb-2">
  <div class="row">
    <div class="col-12">
      <div class="float-left">
        <span class="fb-page-title">{{ formBuilderInfo.pageTitle }}</span>
        <span class="fb-page-sub-title">{{ formBuilderInfo.pageSubTitle }}</span>
      </div>

    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="float-right action_button_position"
        *ngIf="(pageFormType  === 'master_listing_table' && !showSimpleForm) || (pageFormType  === 'form_builder_dashboard')">
        <!-- <button pButton class="fb-form-btn" type="button" [title]="item.name" [label]="item.name"
            *ngFor="let item of formBuilderInfo.formBuilderPageFormButtons" (click)="pageFormButtonClick(item)"></button> -->
        <div *ngFor="let item of formBuilderInfo.formBuilderPageFormButtons; let i = index" class="float-right"
          [ngClass]="{'ml-3': i < (formBuilderInfo.formBuilderPageFormButtons.length - 1) }">
          <ng-template [ngIf]="item.name !== 'fb-simple-form-build-form-type'">
            <button pButton class="fb-form-btn" type="button" [title]="item.name" [label]="item.name"
              (click)="pageFormButtonClick(item)"></button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>